import { useTranslation } from 'react-i18next';

export function Fallback() {
  const { t } = useTranslation();
  return <p className={'text-basic text-center'}>{t('fleet.error')}</p>;
}
